var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFootfall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "154.000000pt",
    height: "210.000000pt",
    viewBox: "0 0 154.000000 210.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,210.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1131 2059 c-103 -52 -178 -166 -222 -339 -19 -75 -21 -99 -14 -215 11 -184 11 -312 1 -370 -12 -76 2 -87 164 -135 134 -39 183 -47 208 -32 7 5 34 57 61 118 27 60 65 144 85 188 67 147 87 215 93 316 13 218 -70 424 -192 481 -59 27 -112 24 -184 -12z m202 -36 c87 -61 142 -215 142 -398 0 -130 -12 -172 -115 -395 -37 -80 -73 -161 -80 -180 -18 -48 -29 -60 -54 -60 -37 1 -289 78 -298 92 -4 7 -5 31 -1 53 10 49 9 199 -2 365 -7 111 -5 134 14 210 69 274 248 417 394 313z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225 1472 c-77 -36 -139 -127 -176 -257 -9 -32 -14 -99 -14 -185 0 -159 2 -167 115 -415 42 -93 83 -185 90 -203 14 -37 36 -52 76 -52 27 0 246 62 289 82 26 12 48 53 41 77 -20 63 -23 157 -9 268 26 203 5 349 -69 497 -36 71 -108 151 -162 178 -57 29 -132 33 -181 10z m176 -43 c104 -52 202 -248 216 -429 3 -46 -1 -126 -11 -207 -14 -103 -15 -144 -7 -189 16 -84 14 -122 -6 -133 -27 -14 -260 -81 -282 -81 -24 0 -34 12 -66 89 -14 35 -48 110 -75 168 -84 177 -102 236 -107 348 -4 70 -1 124 10 176 49 238 175 337 328 258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867 965 c-20 -20 -41 -128 -32 -171 10 -58 41 -110 82 -141 32 -25 45 -28 108 -28 64 0 76 3 109 29 56 42 112 178 88 213 -4 7 -78 33 -163 58 -85 25 -159 48 -166 50 -7 2 -19 -2 -26 -10z m183 -69 l145 -43 -3 -33 c-6 -51 -39 -114 -75 -141 -26 -19 -44 -24 -94 -24 -55 0 -65 3 -93 30 -59 56 -77 116 -60 200 6 30 17 55 23 55 7 -1 77 -20 157 -44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495 331 c-88 -26 -166 -50 -173 -55 -29 -17 3 -138 51 -193 105 -119 290 -64 326 97 8 34 6 63 -4 115 -8 39 -15 71 -15 71 0 14 -54 3 -185 -35z m171 -47 c13 -108 -7 -165 -76 -212 -45 -30 -115 -30 -161 1 -38 25 -77 95 -81 147 l-3 34 140 42 c77 23 148 43 157 43 13 1 18 -11 24 -55z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootfall);
export default __webpack_public_path__ + "static/media/Footfall.2acd823ef7f77d2e71a2ee4767034a3c.svg";
export { ForwardRef as ReactComponent };